var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1001_99)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7413 45.3521C38.4014 46.4381 37.5617 47.2978 36.5009 47.6458C37.5617 47.9939 38.4014 48.8535 38.7413 49.9396C39.0812 48.8535 39.9206 47.9939 40.9814 47.6458C39.9206 47.2978 39.0812 46.4385 38.7413 45.3521Z",
    fill: "url(#paint0_linear_1001_99)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.852 21.873C44.0855 26.2399 40.714 29.692 36.4494 30.4771C40.714 31.2618 44.0855 34.7143 44.852 39.0808C45.6185 34.7139 48.99 31.2618 53.2546 30.4771C48.99 29.692 45.6185 26.2399 44.852 21.873Z",
    fill: "url(#paint1_linear_1001_99)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7183 33.7823C30.1956 36.0163 28.4746 37.7787 26.2926 38.3138C28.4746 38.849 30.1959 40.6113 30.7183 42.8453C31.241 40.6113 32.962 38.849 35.1441 38.3138C32.962 37.7787 31.241 36.0163 30.7183 33.7823Z",
    fill: "url(#paint2_linear_1001_99)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1001_99",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1001_99"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1001_99",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1001_99",
    x1: 31.1866,
    y1: 29.6349,
    x2: 48.2901,
    y2: 39.2801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1001_99",
    x1: 31.1866,
    y1: 29.6349,
    x2: 48.2901,
    y2: 39.2801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1001_99",
    x1: 31.1866,
    y1: 29.6349,
    x2: 48.2901,
    y2: 39.2801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBot);
export default __webpack_public_path__ + "static/media/chat_bot.3d73fae117d4bd259d25a68a2fed5d17.svg";
export { ForwardRef as ReactComponent };